// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2HczY","inputWrap":"Table_inputWrap__28QIB","col":"Table_col__Sdytn","bmiTooltip":"Table_bmiTooltip__raRRX"};